module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-34.8df13730.png";